import { Injectable, inject } from '@angular/core';
import {
  AssetService,
  PlantEvent,
  MachineEvent,
  MachineGroupEvent,
  ToolingEvent,
  ToastV2Service,
} from '@schenck/rotec-components';

@Injectable()
export class AssetToastService {
  constructor() {
    const toastV2Service = inject(ToastV2Service);
    const assetService = inject(AssetService);

    this.setupAssetListener(assetService, toastV2Service);
  }

  private setupAssetListener(assetService: AssetService, toastV2Service: ToastV2Service) {
    // No unsubscribe needed because this service lives the whole browsersession.
    assetService.events$.subscribe((event) => {
      toastV2Service.open({
        type: 'success',
        positioning: 'top',
        title: this.getBannerHeaderText(event) as 'Success',
        text: 'The view was updated automatically.',
      });
    });
  }

  private getBannerHeaderText(event: PlantEvent | MachineEvent | MachineGroupEvent | ToolingEvent) {
    switch (event) {
      case PlantEvent.created:
        return 'Plant created';
      case PlantEvent.updated:
        return 'Plant updated';
      case PlantEvent.deleted:
        return 'Plant deleted';
      case MachineEvent.created:
        return 'Machine created';
      case MachineEvent.updated:
        return 'Machine updated';
      case MachineEvent.deleted:
        return 'Machine deleted';
      case ToolingEvent.created:
        return 'Tooling created';
      case ToolingEvent.updated:
        return 'Tooling updated';
      case ToolingEvent.deleted:
        return 'Tooling deleted';
      case MachineGroupEvent.created:
        return 'Group created';
      case MachineGroupEvent.updated:
        return 'Group updated';
      case MachineGroupEvent.deleted:
        return 'Group deleted';
      default:
        return '';
    }
  }
}
